import React, { Component } from 'react';
import Auth from 'j-toker';
import { MdWarning as WarningIcon } from 'react-icons/md';
import RegistrationForm from './RegistrationForm';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import { updateLanguage } from 'react-localize-redux';
import { getTranslatedString } from 'helpers/i18n';

export default connect(
  (store) => {
    return {
      property_id: store.redirection.property_id,
      referrer: store.redirection.referrer,
      loginType: store.authentication.loginType,
    };
  },
  { updateLanguage }
)(
  class ApplicationRegistration extends Component {
    constructor(props) {
      super(props);
      this.state = {
        errorMessage: null,
        isRegistering: false,
        submitMessage: getTranslatedString(
          'tenantPortal.applicationRegistration.submitMessage.getStarted'
        ),
      };
    }

    register = (values) => {
      this.setState({
        isRegistering: true,
        submitMessage: getTranslatedString(
          'tenantPortal.applicationRegistration.submitMessage.creatingAccount'
        ),
      });
      const auth = Auth;
      Auth.emailSignUp({
        first_name: values.first_name,
        last_name: values.last_name,
        phone_number: values.phone_number.replace(/[()\\s-]+/gi, ''),
        email: values.email,
        password: values.password,
        password_confirmation: values.password_confirmation,
        property_uuid: this.props.property_id,
      })
        .then((response) => {
          auth.configDfd = null;
          if (response.data.id !== undefined) {
            Auth.emailSignIn({
              username: values.email,
              password: values.password,
              config: this.props.loginAuth,
            })
              .then((response) => {
                auth.configDfd = null;
                this.setState({
                  isRegistering: true,
                  submitMessage: getTranslatedString(
                    'tenantPortal.applicationRegistration.submitMessage.signingIn'
                  ),
                });
                if (response.data.id !== undefined) {
                  let route = `/tenant_application?property_id=${this.props.property_id}`;
                  if (this.props.referrer) {
                    route += `&referrer=${this.props.referrer}`;
                  }

                  this.props.router.replace(route);
                }
              })
              .catch((error) => {
                auth.configDfd = null;
                console.error(error.data.errors);
              });
          }
        })
        .catch((error) => {
          auth.configDfd = null;
          console.error(error.data.errors);

          let errorMessage = {};
          if (error.data.errors) {
            errorMessage = {
              errorMessage: (
                <div>
                  <WarningIcon /> {error.data.errors.full_messages.join(', ')}
                </div>
              ),
            };
          } else {
            errorMessage = {
              errorMessage: (
                <div>
                  <WarningIcon />
                  {getTranslatedString('unknownError')}
                </div>
              ),
            };
          }
          this.setState({ ...errorMessage });
        });
    };

    render() {
      const style = {
        transactionCard: {
          color: '#424242 !important',
          fontFamily: '"Circular", sans-serif !important',
          height: '100%',
          overflow: 'hidden',
          borderRadius: '8px',
          padding: '15px',
          marginTop: '15px',
        },
      };

      return (
        <div className="center-form" style={{ minWidth: '320px' }}>
          <style>
            {`body{
              background-color: #e9ecf0
            }`}
          </style>
          <Card style={style.transactionCard}>
            <CardContent expandable={true} style={{ padding: '0 0 10px' }}>
              <div>
                <h3 style={{ padding: '0 0 10px' }}>
                  {getTranslatedString('tenantPortal.applicationRegistration.header.signUpApp')}
                </h3>
                <div className="error-message">{this.state.errorMessage}</div>
              </div>
              <RegistrationForm
                onSubmit={this.register}
                isRegistering={this.state.isRegistering}
                submitMessage={this.state.submitMessage}
                handleLanguageChange={this.props.updateLanguage}
              />
              <div id="account-links-container">
                <p className="account-link">
                  <a href={'/' + browserHistory.getCurrentLocation().search}>
                    {getTranslatedString('tenantPortal.applicationRegistration.alreadyMember')}
                  </a>
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      );
    }
  }
);
